export default __webpack_public_path__ + "static/media/Rakhi Israni.f18fd03a.jpg";